// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"855e4443","399":"855e4443","403":"855e4443","489":"855e4443","891":"855e4443","984":"855e4443"}[chunkId] + ".chunk.css";
};